
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherItemsGrid extends Serenity.EntityGrid<GiftVoucherItemsRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherItems'; }
        protected getDialogType() { return GiftVoucherItemsDialog; }
        protected getIdProperty() { return GiftVoucherItemsRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherItemsRow.localTextPrefix; }
        protected getService() { return GiftVoucherItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}